import { SafeAreaView, TouchableOpacity, View, Text } from "react-native";
import { useCallback, useEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import {
	HomeScreenNavigationProp,
	PaymentScreenNavigationProp,
	routeHome,
	routePayment,
	routeTitleDetails,
	TitleDetailsScreenNavigationProp,
} from "../../Routes";
import { mid_blue, white_smoke, highlightColor, errorColor } from "../../StyleHelpers";
import { Metadata } from "../../models/Metadata";
import TopAppBar from "../../components/TopAppBar/index";
import closeIcon from "../../assets/TopNavBarIcon/icon_nav_close.svg";
import backIcon from "../../assets/TopNavBarIcon/icon_nav_back.svg";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import Toast from "../../components/Toast";
import { AsyncStorageKeys, CarActivity, PurchaseTransactionType } from "../../Types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import useGenericContentStore from "../../store/genericContent.store";
import { AppLogger } from "../../utils/AppLogger";
import { capitalize, convertToLanguage, countryDataList, generateSecurityCodePlaceholder, getCurrencySymbol, globalAny } from "../../utils/Utils";
import Marker from "../../components/Stepper/Marker/Marker";
import { Title } from "../../components/Stepper/Title";
import { Stepper } from "../../components/Stepper";
import BillingInformation from "./BillingInformation";
import CardDetails from "./CardDetails";
import CustomizeDialogBox from "../../components/DialogMessageBox/CustomizeDialogBox";
import { checkEnrollment, paymentAuthorization, productPrice, setup, tax } from "../../services/paymentService";
import { addTransactionEvent, confirm, generateCaptureContext, preverify, verify } from "../../services/purchaseService";
import PurchaseOptions from "./PurchaseOptions";
import PrivacyPolicy from "../../components/PrivacyPolicy";
import useLegalContentStore from "../../store/useLegalContent.store";
import PaymentLoader from "../../components/Loaders/PaymentLoader";
import usePaymentTransactionStore from "../../store/usePaymentTransaction.store";
import { ProductTierDetails } from "../../models/ProductTierDetails";
import { TaxAddress } from "../../models/TaxAddress";
import { TaxModel } from "../../models/TaxModel";
import CarActivityDialog from "../../components/CarActivityDialog";
import useMovieContentStore from "../../store/useMovieContent.store";
import useDrivingStore from "../../store/useDriving.store";
import ENVIRONMENT from "../../config/ENVIRONMENT";
import { DEFAULT_ENV, hostUrl } from "../../config/ENV_CONFIG";
import { Portal, Provider } from "react-native-paper";
import { getAvailableAudioLanguages } from "../../services/videoService";
import { responseOk } from "../../utils/ValidateResponse";
import { getAvailability } from "../../services/metadataService";
import { debounce } from "lodash";
import { PaymentGateway } from "../../enums/PaymentGateway";
import { PurchaseProductType } from "../../enums/PurchaseProductType";
import { PaymentMethod } from "../../enums/PaymentMethod";
import { SetupRequest } from "../../models/request/SetupRequest";
import { TransactionEventType } from "../../enums/TransactionEventType";
import { CheckEnrollmentStatus } from "../../enums/CheckEnrollmentStatus";
import { PaymentAuthorizationRequest } from "../../models/request/PaymentAuthorizationRequest";
import { CheckEnrollmentRequest } from "../../models/request/CheckEnrollmentRequest";
import { jwtDecode } from "jwt-decode";
import { CaptureContextJwtPayload } from "../../models/payment/CaptureContextJwtPayload";
import { RenderButton } from "./PaymentLayout";
import {
	ButtonContainer,
	ContentContainer,
	StepperContainer,
	StyledContainer,
	StyledFormContainer,
	StyledFrame,
	StyledModal,
	StyledSubmitButton,
} from "./styled";
import PaymentNarrowLoader from "../../components/Loaders/PaymentNarrowLoader";

//For Flex microform creation
let number: any;
let securityCode: any;
const rent = "Rent";
let codeLength: any;
let isEmptyCardNumber = true;
let isEmptySecurityNumber = true;
let creditCardError = false;
let securityNumberError = false;
let narrowScreen = false;
//For V8 payment
const paymentGateway: PaymentGateway = PaymentGateway.CyberSource;
const purchaseProductType: PurchaseProductType = PurchaseProductType.ParentProduct;
const paymentMethod: PaymentMethod = PaymentMethod.CreditCard;
const transactionMode: string = "S";

const PaymentScreen = (props: any) => {
	const { route } = props;
	const { parentProductId, paymentType } = route.params;
	// Navigation
	const navigationHome = useNavigation<HomeScreenNavigationProp>();
	const navigationPayment = useNavigation<PaymentScreenNavigationProp>();
	const navigationTitleDetails = useNavigation<TitleDetailsScreenNavigationProp>();
	const navigation = useNavigation<any>();

	// Stores
	const { data: movieStoreValue, fetchTitleDetails } = useMovieContentStore((state) => ({
		data: state.data,
		fetchTitleDetails: state.fetchTitleDetails,
	}));

	const { setSelectedTabs, setIsSuccess, mistakeCount, setMistakeCount, setIsRenderRedeem, isNarrow } = useGenericContentStore((state: any) => ({
		setSelectedTabs: state.setSelectedTabs,
		setIsSuccess: state.setIsSuccess,
		mistakeCount: state.mistakeCount,
		setMistakeCount: state.setMistakeCount,
		setIsRenderRedeem: state.setIsRenderRedeem,
		isNarrow: state.isNarrow,
	}));

	const { purchasePrice, rentPrice, setPurchasePrice, setRentPrice, currencySymbol } = usePaymentTransactionStore((state: any) => ({
		purchasePrice: state.purchasePrice,
		rentPrice: state.rentPrice,
		setPurchasePrice: state.setPurchasePrice,
		setRentPrice: state.setRentPrice,
		currencySymbol: state.currencySymbol,
	}));

	const { carActivity } = useDrivingStore((state: any) => ({
		carActivity: state.carActivity,
	}));

	// Local state
	const expiryDate = document.querySelector<HTMLInputElement>("#expiryDate");
	const [metadata, setMetadata] = useState<Metadata>();
	const [visible, setVisible] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [title, setTitle] = useState("");
	const [termOfService, setTermOfService] = useState(false);
	const [isTermOfService, setIsTermOfService] = useState(false);
	const [labelText, setLabelText] = useState("");
	const [type, setType] = useState(ComponentTypeEnum.Secondary);
	const [step, setStep] = useState(0);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [confirmCallBack, setConfirmCallBack] = useState("");
	const [captureContext, setCaptureContext] = useState<any>();
	const [flexMicroFormScriptLoaded, setFlexMicroFormScriptLoaded] = useState(false);
	const [flexMicroform, setFlexMicroform] = useState();
	const [transactionId, setTransactionId] = useState("");
	const [transientToken, setTransientToken] = useState("");
	const [product, setProduct] = useState<ProductTierDetails>();
	const [taxDetails, setTaxDetails] = useState<TaxModel>();
	const [isProcessing, setIsProcessing] = useState(false);
	const [isProcessPurchase, setIsProcessPurchase] = useState(false);
	const [deviceDataCollectionUrl, setDeviceDataCollectionUrl] = useState("");
	const [cardinalAccessToken, setCardinalAccessToken] = useState("");
	const [stepUrl, setStepUrl] = useState("");
	const [stepUrlAccessToken, setStepUrlAccessToken] = useState("");
	const [sessionId, setSessionId] = useState("");
	const [loading, setLoading] = useState(true);
	const [showAuthPayer, setShowAuthPayer] = useState(false);
	const [movieAvailableLang, setMovieAvailableLang] = useState("");
	const [disabledNext, setDisabledNext] = useState(false);
	const [disabledPrevious, setDisabledPrevious] = useState(false);
	const [isFlexLimit, setIsFlexLimit] = useState(false);
	const [toastDuration, setToastDuration] = useState(5500);
	const [expiryError, setExpiryError] = useState(false);

	// Handlers
	const onDismissSnackBar = () => setVisible(false);

	// Personal Info
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");

	// Card Details
	const [cardName, setCardName] = useState("");
	const [cardNumberDetails, setCardNumber] = useState(true);
	const [cardExpiry, setCardExpiry] = useState("");
	const [cardCVV, setCardCVV] = useState(true);

	// Billing Info
	const [address, setAddress] = useState("");
	const [address2, setAddress2] = useState("");
	const [country, setCountry] = useState("");
	const [state, setState] = useState("");
	const [city, setCity] = useState("");
	const [postalCode, setPostalCode] = useState("");
	const [countryName, setCountryName] = useState("");
	const [stateName, setStateName] = useState("");

	// end of ProductCheckout Related States
	const legalStoreValue = useLegalContentStore((state: any) => state.data);

	const wording = {
		movieNotAvailable: globalAny.language.movie_not_available_user,
		movieAlreadyOwned: globalAny.language.movie_already_owned,
		errorValidation: globalAny.language.error_validation,
		validatedAddress: globalAny.language.validated_address,
		retryLimit: globalAny.language.retry_limit,
		invalidSecurityCode: globalAny.language.invalid_security_code,
		invalidCreditCard: globalAny.language.invalid_credit_card,
		errorOccurred: globalAny.language.error_occurred,
		validatingDoNotStray: globalAny.language.validating_do_not_stray,
		taxApply: globalAny.language.tax_apply,
		invalidExpiryDate: globalAny.language.invalid_expiry_date,
		authenticationFailed: globalAny.language.authentication_failed,
	};

	const stylesIframe = {
		display: "none",
	};

	const customizeStyle = {
		background: white_smoke,
		padding: 20,
		zIndex: 1005,
		borderRadius: 16,
	};

	//#region Function
	const startCountdownAndHandleError = async () => {
		try {
			const currentTime = new Date().getTime();
			const waitingPeriod = 15 * 1000;
			const newAllowUntil = currentTime + waitingPeriod;
			await AsyncStorage.setItem(AsyncStorageKeys.allowUntil, newAllowUntil.toString());
		} catch (error) {
			AppLogger.error(error);
		}
	};

	const init = () => {
		try {
			fetchTitleDetails(parentProductId, false);
			fetchPrice();
			fetchAudioLanguages();
			setIsRenderRedeem(false);
		} catch (err) {
			AppLogger.log(err);
		}
	};

	const initFlexMicroFormScript = (captureContext: string) => {
		const scriptId = "flexMicroFormScript";
		let scriptElement = document.getElementById(scriptId) as HTMLScriptElement;

		if (scriptElement) {
			document.body.removeChild(scriptElement);
		}

		const decodedJwt = jwtDecode<CaptureContextJwtPayload>(captureContext);
		const { clientLibrary, clientLibraryIntegrity } = decodedJwt.ctx[0].data;

		scriptElement = document.createElement("script");
		scriptElement.id = scriptId;
		scriptElement.type = "text/javascript";
		scriptElement.async = true;
		scriptElement.src = clientLibrary;
		scriptElement.integrity = clientLibraryIntegrity;
		scriptElement.crossOrigin = "anonymous";
		document.body.appendChild(scriptElement);

		scriptElement.onload = () => {
			if (typeof (window as any).Flex !== "undefined") {
				setFlexMicroFormScriptLoaded(true);
			} else {
				setFlexMicroFormScriptLoaded(false);
			}
		};

		scriptElement.onerror = () => {
			setFlexMicroFormScriptLoaded(false);
		};
	};

	const generate3dsCallbackScript = () => {
		return `
		function closeConsumerAuthModal() {
			document.querySelector('#cs-3ds-callback-button').click();
		}
		`;
	};

	const init3dsCallback = () => {
		const scriptId = "threeDSCallbackScript";
		let scriptElement = document.getElementById(scriptId) as HTMLScriptElement;
		if (!scriptElement) {
			scriptElement = document.createElement("script");
			scriptElement.id = scriptId;
			scriptElement.type = "text/javascript";
			scriptElement.async = true;
			scriptElement.text = generate3dsCallbackScript();
			document.body.appendChild(scriptElement);
		}
	};

	const initialize3dsPayerSetup = async () => {
		const payerSetupRequest: SetupRequest = {
			paymentData: {
				token: transientToken,
				paymentMethod: paymentMethod,
			},
		};
		setIsProcessPurchase(true);

		const payerSetupResponse = await setup(transactionId, payerSetupRequest);
		if (payerSetupResponse.responseCode !== 10000) {
			await addTransactionEvent(transactionId, TransactionEventType.SetupError, JSON.stringify(payerSetupResponse));
			purchaseCheckoutError();
			setIsProcessPurchase(false);
			return;
		}

		// setup success
		setCardinalAccessToken(payerSetupResponse.accessToken);
		setDeviceDataCollectionUrl(payerSetupResponse.deviceDataCollectionUrl);
		//Device Data Collection submit
		setTimeout(() => {
			const cardinalCollectionForm = document.querySelector("#cardinal_collection_form") as HTMLFormElement;
			if (cardinalCollectionForm) {
				// form exists
				cardinalCollectionForm.submit();
			}
		}, 1000);
	};

	const getReturnUrl = () => {
		if (DEFAULT_ENV === ENVIRONMENT.UAT) {
			return "https://uat.ridevudemo.com/purchase/v1/redirect";
		}

		if (DEFAULT_ENV === ENVIRONMENT.PRODUCTION) {
			return "https://www.ridevudemo.com/purchase/v1/redirect";
		}

		return "https://staging.ridevudemo.com/purchase/v1/redirect";
	};

	const onCheckEnrollment = async (referenceId: string) => {
		const payerCheckRequest: CheckEnrollmentRequest = {
			paymentData: {
				token: transientToken,
				paymentMethod: paymentMethod,
			},
			authData: {
				referenceId: referenceId,
				transactionMode: transactionMode,
				returnUrl: getReturnUrl(),
			},
			billingAddress: {
				firstName: firstName,
				lastName: lastName,
				email: localStorage.getItem("email") ?? "",
				line1: address,
				line2: address2,
				country: country,
				region: state,
				postalCode: postalCode,
				city: city,
				phoneNumber: null,
			},
			deviceInformation: {
				httpBrowserJavaEnabled: null,
				httpBrowserLanguage: window.navigator.language,
				httpBrowserColorDepth: window.screen.colorDepth,
				httpBrowserTimeDifference: null,
				httpBrowserJavaScriptEnabled: true,
				httpBrowserScreenHeight: window.screen.height,
				httpBrowserScreenWidth: window.screen.width,
			},
		};

		const payerCheckResponse = await checkEnrollment(transactionId, payerCheckRequest);

		if (payerCheckResponse.responseCode !== 10000) {
			await addTransactionEvent(transactionId, TransactionEventType.CheckEnrollmentError, JSON.stringify(payerCheckResponse));
			purchaseCheckoutError();
			setIsProcessPurchase(false);
			return;
		}

		if (payerCheckResponse.status === CheckEnrollmentStatus.Pending) {
			setStepUrl(payerCheckResponse.stepUpUrl);
			setStepUrlAccessToken(payerCheckResponse.accessToken);
			setShowAuthPayer(true);

			//Step up form submit
			setTimeout(() => {
				const stepUpForm = document.querySelector("#step-up-form") as HTMLFormElement;

				if (stepUpForm) {
					// form exists
					stepUpForm.submit();
				}
				setIsProcessPurchase(false);
			}, 1000);
		} else if (payerCheckResponse.status === CheckEnrollmentStatus.Successful) {
			pay();
		} else if (payerCheckResponse.status === CheckEnrollmentStatus.Failed) {
			setVisible(false);
			popUpError(ComponentTypeEnum.Error, wording.authenticationFailed, 5500);
			setIsProcessPurchase(false);
		} else {
			purchaseCheckoutError();
			setIsProcessPurchase(false);
		}
	};

	const onPressToast = (command: string) => {
		if (command === globalAny.language.label_retry) {
			navigationPayment.replace(routePayment, { parentProductId, paymentType: paymentType });
			return;
		}

		initialize3dsPayerSetup();
	};

	/**
	 * Fetch price of current ProductId
	 * Note: currency symbol is not yet dynamic.
	 */
	const fetchPrice = async () => {
		const prices: any = await productPrice(parentProductId);
		const [purchasePrice] =
			prices?.productTierDetails?.filter((product: any) => product.transactionTypeId === PurchaseTransactionType.Purchase) ?? [];
		const [rentPrice] = prices?.productTierDetails?.filter((product: any) => product.transactionTypeId === PurchaseTransactionType.Rent) ?? [];

		if (purchasePrice) {
			setPurchasePrice(purchasePrice?.price);
		}

		if (rentPrice) {
			setRentPrice(rentPrice?.price);
		}

		return prices;
	};

	const getPaymentType = () => {
		return capitalize(paymentType) === rent ? PurchaseTransactionType.Rent : PurchaseTransactionType.Purchase;
	};

	const transactionDetailsError = () => {
		setVisible(false);
		startCountdownAndHandleError();
		setLabelText("");
		AppLogger.error("transactionDetailsError", "error");
		popUpError(ComponentTypeEnum.Error, wording.errorValidation, 5500);
		setTimeout(() => {
			navigationTitleDetails.navigate(routeTitleDetails, { parentProductId });
		}, 5000);
	};

	const initTransactionDetails = async () => {
		try {
			const prices = await fetchPrice();
			if (prices.responseCode !== 10000) {
				transactionDetailsError();
				return;
			}
			const [purchaseTypePrice] = prices.productTierDetails.filter((product: any) => product.transactionTypeId === getPaymentType());
			setProduct(purchaseTypePrice);

			const preverifyResponse = await preverify(parentProductId, paymentGateway, purchaseProductType, purchaseTypePrice as ProductTierDetails);
			if (preverifyResponse.responseCode !== 10000) {
				transactionDetailsError();
				return;
			}
			setTransactionId(preverifyResponse?.transactionId);
			const captureContextResponse = await generateCaptureContext(preverifyResponse?.transactionId);
			if (captureContextResponse.responseCode !== 10000) {
				await addTransactionEvent(
					preverifyResponse?.transactionId,
					TransactionEventType.CaptureContextError,
					JSON.stringify(captureContextResponse),
				);
				transactionDetailsError();
				return;
			}
			initFlexMicroFormScript(captureContextResponse.captureContext);
			setCaptureContext(captureContextResponse.captureContext);
			setMistakeCount(0);
		} catch {
			popUpError(ComponentTypeEnum.Error, wording.errorValidation, 5000);
		}
	};

	const popUpError = (type: ComponentTypeEnum, message: string, timeout: number, isLimit?: boolean) => {
		setType(type);
		setToastMessage(message);
		setToastDuration(timeout);
		setVisible(true);
		if (isLimit) {
			setTimeout(() => {
				back();
			}, timeout);
		}
	};

	const initFlexMicroform = (captureContextParam: string) => {
		if (!captureContextParam) {
			setVisible(false);
			popUpError(
				ComponentTypeEnum.Secondary,
				wording.errorOccurred.replace("%d", paymentType === rent.toLowerCase() ? globalAny.language.rent : globalAny.language.purchase_word),
				5500,
			);
			return;
		}
		try {
			let cardNumber: any = document.querySelector("#number-container");
			let securityNumber: any = document.querySelector("#securityCode-container");
			let cardNumberLabel: any = document.querySelector("#floating-label");
			let securityNumberLabel: any = document.querySelector("#floating-label-securityCode");
			let cardNumberPadding: any = document.querySelector("#cardNumberPadding");
			let securityCodePadding: any = document.querySelector("#securityCodePadding");
			isEmptyCardNumber = true;
			isEmptySecurityNumber = true;

			let myStyles = {
				input: {
					"font-size": "25px",
					"font-weight": 400,
					"font-stretch": "normal",
					"font-style": "normal",
					color: white_smoke,
				},
				":focus": { color: white_smoke },
				":disabled": { cursor: "not-allowed" },
				valid: { color: white_smoke },
				invalid: { color: white_smoke },
				"::placeholder": {
					color: white_smoke,
					opacity: 0.8,
				},
			};

			// @ts-ignores
			let flex = new Flex(captureContextParam);
			let microform = flex.microform({ styles: myStyles });
			setFlexMicroform(microform);

			//micro form create field
			number = microform.createField("number", { placeholder: "", autoformat: false });
			securityCode = microform.createField("securityCode", {
				placeholder: "",
				autoformat: false,
			});

			//load the field
			number.load("#number-container");
			securityCode.load("#securityCode-container");

			number.on("change", function (val: any) {
				codeLength = val?.card[0]?.securityCode?.length;
				isEmptyCardNumber = !!val?.empty;
				setCardNumber(isEmptyCardNumber);
				debouncedOnChange();
				cardNumber.style.borderColor = mid_blue;
			});

			securityCode.on("change", function (val: any) {
				isEmptySecurityNumber = !!val?.empty;
				setCardCVV(isEmptySecurityNumber);
				debouncedOnChange();
				securityNumber.style.borderColor = mid_blue;
			});

			number.on("focus", function () {
				number.update({ placeholder: "0000 0000 0000 0000" });
				if (!creditCardError) {
					cardNumber.style.borderColor = mid_blue;
				}
				cardNumberLabel.style.zIndex = 1;
				cardNumberLabel.style.top = "-14px";
				cardNumberLabel.style.fontSize = narrowScreen ? "15px" : "21px";
				cardNumberLabel.style.left = "12px";
				cardNumberLabel.style.width = "auto";
				cardNumber.style.paddingLeft = "30px";
				cardNumberLabel.style.paddingRight = "10px";
				cardNumberLabel.style.transition = "0.2s ease all";
			});

			securityCode.on("focus", function () {
				securityCode.update({ placeholder: generateSecurityCodePlaceholder(codeLength) || "000", autoformat: false });
				if (!securityNumberError) {
					securityNumber.style.borderColor = mid_blue;
				}
				securityNumberLabel.style.zIndex = 1;
				securityNumberLabel.style.top = "-14px";
				securityNumberLabel.style.fontSize = narrowScreen ? "15px" : "21px";
				securityNumberLabel.style.left = "12px";
				securityNumberLabel.style.width = "auto";
				securityCodePadding.style.paddingLeft = 0;
				securityNumberLabel.style.transition = "0.2s ease all";
			});

			number.on("blur", function () {
				cardNumber.style.borderColor = "rgb(147,143,153)";
				if (isEmptyCardNumber) {
					number.update({ placeholder: "" });
					cardNumberLabel.style.zIndex = -1;
					cardNumberLabel.style.top = narrowScreen ? "13px" : "25px";
					cardNumberLabel.style.fontSize = narrowScreen ? "22px" : "25px";
					cardNumberLabel.style.width = "235px";
					cardNumberLabel.style.left = "15px";
					cardNumberLabel.style.transition = "0.2s ease all";
					cardNumberPadding.style.paddingLeft = "10px";
				} else {
					cardNumber.style.borderColor = white_smoke;
					cardNumberLabel.style.color = white_smoke;
				}

				if (!isEmptySecurityNumber) {
					securityCode.update({ placeholder: generateSecurityCodePlaceholder(codeLength) || "000", autoformat: false });
				}
			});

			securityCode.on("blur", function () {
				securityNumber.style.borderColor = "rgb(147,143,153)";
				if (isEmptySecurityNumber) {
					securityCode.update({ placeholder: "" });

					securityNumberLabel.style.top = narrowScreen ? "13px" : "25px";
					securityNumberLabel.style.fontSize = narrowScreen ? "22px" : "25px";
					securityNumberLabel.style.width = "80px";
					securityNumberLabel.style.left = "15px";
					securityNumberLabel.style.transition = "0.2s ease all";
					securityCodePadding.style.paddingLeft = "10px";
				} else {
					securityNumber.style.borderColor = white_smoke;
					securityNumberLabel.style.color = white_smoke;
				}
			});
		} catch (error: any) {
			setVisible(false);
			AppLogger.error("initFlexMicroform", error);
			popUpError(ComponentTypeEnum.Error, wording.errorValidation, 5500);
		}
	};

	const createTransientTokenError = (errorMessage: any) => {
		if (mistakeCount < 3) {
			setVisible(false);
			AppLogger.error("createTransientTokenError", "error");
			popUpError(ComponentTypeEnum.Error, errorMessage ?? wording.errorValidation, 5500);
			setLabelText(globalAny.language.label_retry);
			setMistakeCount(mistakeCount + 1);
			return;
		}
		startCountdownAndHandleError();

		const allowUntil = new Date().setMinutes(new Date().getMinutes() + 1);
		AsyncStorage.setItem(AsyncStorageKeys.allowUntil, allowUntil.toString());
		setLabelText("");
		setVisible(false);
		popUpError(ComponentTypeEnum.Error, wording.retryLimit, 5500, true);
	};

	/**
	 * Creates a transient token using Cybersource Flex Microform.
	 *
	 * - Retrieves cardholder and expiry data from the DOM.
	 * - Validates expiration date and required fields.
	 * - Calls `flexMicroform.createToken()` with the provided expiration info.
	 * - Handles and logs any errors returned from tokenization.
	 * - On success, stores the token and proceeds to the next step.
	 */
	const createTransientToken = () => {
		const firstName = document.querySelector<HTMLInputElement>("#cardholderFirstName");
		const lastName = document.querySelector<HTMLInputElement>("#cardholderLastName");
		const cardNumberContainer = document.querySelector<HTMLElement>("#number-container");
		const securityCodeContainer = document.querySelector<HTMLElement>("#securityCode-container");

		const [expMonth, expYear] = (expiryDate?.value || "").split("/");
		const currentDate = new Date();
		const currentMonth = currentDate.getMonth() + 1;
		const currentYear = Number(currentDate.getFullYear().toString().slice(-2));

		if (
			!expMonth ||
			!expYear ||
			Number(expMonth) < 1 ||
			Number(expMonth) > 12 ||
			(Number(expMonth) < currentMonth && Number(expYear) <= currentYear)
		) {
			expiryDate?.focus();
			createTransientTokenError(wording.invalidExpiryDate);
			setExpiryError(true);
			return;
		}

		if (!firstName?.value || !lastName?.value || !expiryDate?.value) {
			setVisible(false);
			AppLogger.error("createTransientToken", "error");
			popUpError(ComponentTypeEnum.Error, wording.errorValidation, 5500);
			return;
		}

		const options = {
			expirationMonth: expMonth,
			expirationYear: `20${expYear}`,
		};

		setDisabledNext(true);

		//@ts-ignore
		flexMicroform.createToken(options, (err, token) => {
			try {
				if (err) {
					const location = err.details?.[0]?.location;
					let message = "";

					switch (location) {
						case "number":
							cardNumberContainer?.focus();
							cardNumberContainer!.style.borderColor = errorColor;
							message = wording.invalidCreditCard;
							creditCardError = true;
							break;
						case "expirationYear":
							expiryDate?.focus();
							message = wording.invalidExpiryDate;
							setExpiryError(true);
							break;
						case "securityCode":
							securityCodeContainer?.focus();
							securityCodeContainer!.style.borderColor = errorColor;
							message = wording.invalidSecurityCode;
							securityNumberError = true;
							break;
						default:
							setDisabledNext(false);
							setIsFlexLimit(true);
							return;
					}

					setDisabledNext(false);
					createTransientTokenError(message);
					AppLogger.error(err);
					return;
				}

				setDisabledNext(false);
				setTransientToken(token);
				setStep((prev) => prev + 1);

				if (DEFAULT_ENV !== ENVIRONMENT.PRODUCTION) {
					AppLogger.log(`TransientToken: ${token}`);
				}
			} catch {
				setIsFlexLimit(true);
			}
		});
	};

	const onClose = () => {
		setSelectedTabs(0);
		setStep(0);
		navigationHome.replace(routeHome, {});
	};

	const back = () => {
		setStep(0);
		navigationTitleDetails.navigate(routeTitleDetails, { parentProductId });
	};

	const getTitleBody = () => {
		const currentPaymentType = capitalize(paymentType);
		const isRent = currentPaymentType === rent;
		const word = wording.taxApply
			.replace("%d", paymentType === rent.toLowerCase() ? globalAny.language.rent : globalAny.language.purchase_word)
			.replace("%p", `${currencySymbol}${isRent ? rentPrice : purchasePrice}`);
		return word;
	};

	const calculateTaxError = () => {
		if (mistakeCount < 3) {
			setVisible(false);
			AppLogger.error("calculateTaxError", "error");
			popUpError(ComponentTypeEnum.Error, wording.errorValidation, 5500);
			setLabelText(globalAny.language.label_retry);
			setMistakeCount(mistakeCount + 1);
			return;
		}
		const allowUntil = new Date().setMinutes(new Date().getMinutes() + 1);
		AsyncStorage.setItem(AsyncStorageKeys.allowUntil, allowUntil.toString());
		setLabelText("");
		setVisible(false);
		popUpError(ComponentTypeEnum.Error, wording.retryLimit, 5500, true);
	};

	const calculateTax = async () => {
		setIsProcessing(true);
		onValidateStep();
		const taxRequest: TaxAddress = {
			country: country,
			province: state,
			city: city,
			address: address,
			address2: address2,
			postalCode: postalCode,
		};

		setVisible(true);
		setToastMessage(wording.validatingDoNotStray);
		setType(ComponentTypeEnum.Processing);
		setLabelText("");

		const result: any = await tax(transactionId, taxRequest);
		if (result.responseCode === 10000) {
			setTaxDetails({
				price: addCurrency(result?.price, country, result?.currencyCode),
				totalAmount: addCurrency(result?.totalAmount, country, result?.currencyCode),
				taxAmount: addCurrency(result?.taxAmount, country, result?.currencyCode),
				taxRate: result?.taxRate.toFixed(2),
				taxType: result?.taxType,
			});
			setVisible(false);
			setStep((prevStep) => prevStep + 1);
			setMistakeCount(0);
			setIsProcessing(false);
			return;
		}
		setIsProcessing(false);
		calculateTaxError();
	};

	const addCurrency = (price: number, countryCode: string, currencyCode: any) => {
		try {
			const region = localStorage.getItem(AsyncStorageKeys.RegionOverride);
			let updatedPrice;
			const noDecimal = countryDataList?.control.some((item) => region === item.countryCode && item.noDecimal);

			if (noDecimal) {
				updatedPrice = price;
			} else {
				updatedPrice = price.toFixed(2);
			}

			return `${getCurrencySymbol(currencyCode)}${updatedPrice}`;
		} catch {
			setVisible(false);
			AppLogger.error("addCurrency", "error");
			popUpError(ComponentTypeEnum.Error, wording.errorValidation, 5500);
		}
	};

	const onPressNext = () => {
		switch (step) {
			case 0:
				createTransientToken();
				return;
			case 1:
				calculateTax();
				return;
			case 2:
				initialize3dsPayerSetup();
				return;
			default:
				setStep((prevStep) => prevStep + 1);
				return;
		}
	};

	const onPressPrevious = () => {
		setDisabledPrevious(true);
		if (isTermOfService) {
			setIsTermOfService(false);
			return;
		}

		setTimeout(() => {
			setDisabledPrevious(false);
			setStep((prevStep) => prevStep - 1);
		}, 350);
	};

	const getConfirmCallBack = () => {
		setShowConfirmModal(false);
		setIsFlexLimit(false);
		switch (confirmCallBack) {
			case "back":
				return back();
			case "close":
				return onClose();
		}
	};

	/**
	 * checks if the step is valid to proceed
	 * @returns {boolean} - returns true if all required fields are filled up
	 */
	const onValidateStep = (currentStep?: any) => {
		const stepToProcess = currentStep ?? step;
		const isCardDetailsValid = firstName && lastName && !cardNumberDetails && cardExpiry && !cardCVV;
		const isBillingValid = address && country && state && city && postalCode;
		if (isProcessing) {
			return false;
		}

		if (stepToProcess === 0) {
			return isCardDetailsValid;
		} else if (stepToProcess === 1) {
			return isBillingValid;
		} else if (stepToProcess === 2) {
			return isCardDetailsValid && isBillingValid;
		}
	};

	const confirmExit = (callback: any) => {
		if (isTermOfService) {
			setIsTermOfService(false);
			return;
		}

		setIsFlexLimit(false);
		setShowConfirmModal(true);
		setConfirmCallBack(callback);
	};

	const onPressTermsAndService = async () => {
		setIsTermOfService(true);
		setTitle(globalAny.language.terms_of_service);
		const resultLegal = await legalStoreValue.legalData[AsyncStorageKeys.legals];
		const data = resultLegal?.legalContents?.filter((val: any) => val?.type === 3)[0].htmlContent;
		setTermOfService(data);
	};

	const purchaseCheckoutError = () => {
		if (mistakeCount < 3) {
			setVisible(false);
			AppLogger.error("purchaseCheckoutError", "error");
			popUpError(ComponentTypeEnum.Error, wording.errorValidation, 5500);
			setLabelText(globalAny.language.label_retry);
			setMistakeCount(mistakeCount + 1);
			return;
		}
		startCountdownAndHandleError();

		const allowUntil = new Date().setMinutes(new Date().getMinutes() + 1);
		AsyncStorage.setItem(AsyncStorageKeys.allowUntil, allowUntil.toString());
		setLabelText("");
		setVisible(false);
		popUpError(ComponentTypeEnum.Error, wording.retryLimit, 5500, true);
	};

	const closePayerAuth = () => {
		setShowAuthPayer(false);
		pay();
	};

	const debouncedOnChange = useCallback(
		debounce(() => {
			setDisabledNext(!!onValidateStep());
		}, 1000),
		[],
	);

	const pay = async () => {
		setIsProcessPurchase(true);
		setIsProcessing(true);
		onValidateStep();
		const checkoutDetails: PaymentAuthorizationRequest = {
			paymentData: {
				token: transientToken,
				paymentMethod: paymentMethod,
				saveCard: null,
			},
			billingAddress: {
				firstName: firstName,
				lastName: lastName,
				email: localStorage.getItem("email") ?? "test@gmail.com",
				line1: address,
				line2: address2,
				country: country,
				region: state,
				postalCode: postalCode,
				city: city,
				phoneNumber: null,
			},
			deviceFingerPrint: null,
		};

		const paymentAuthorizationResponse = await paymentAuthorization(transactionId, checkoutDetails);
		if (paymentAuthorizationResponse?.responseCode !== 10000) {
			await addTransactionEvent(transactionId, TransactionEventType.PaymentError, JSON.stringify(paymentAuthorizationResponse));
			setIsProcessPurchase(false);
			setIsProcessing(false);
			purchaseCheckoutError();
			return;
		}

		const verifyResponse = await verify(transactionId, parentProductId, paymentGateway, purchaseProductType, product as ProductTierDetails);
		if (verifyResponse?.responseCode !== 10000) {
			await addTransactionEvent(transactionId, TransactionEventType.VerifyError, JSON.stringify(verifyResponse));
			setIsProcessPurchase(false);
			setIsProcessing(false);
			purchaseCheckoutError();
			return;
		}

		const confirmResponse = await confirm(transactionId, paymentGateway, purchaseProductType, product as ProductTierDetails);
		if (confirmResponse?.responseCode !== 10000) {
			await addTransactionEvent(transactionId, TransactionEventType.ConfirmError, JSON.stringify(confirmResponse));
			setIsProcessPurchase(false);
			setIsProcessing(false);
			purchaseCheckoutError();
			return;
		}

		// successful payment if no error occured
		setIsSuccess(true, getPaymentType() === 3);
		setIsProcessPurchase(false);
		setIsProcessing(false);
		navigationTitleDetails.navigate(routeTitleDetails, { parentProductId });
	};

	const fetchAudioLanguages = async () => {
		const availability: any = await getAvailability(parentProductId);
		const availableLanguages: any = await getAvailableAudioLanguages(parentProductId, 1080, availability?.transactionTypes[0], "");
		if (availableLanguages.responseCode === responseOk) {
			const audio = convertToLanguage(availableLanguages.audioLanguages);
			const subtitle = convertToLanguage(availableLanguages.subtitleLanguages);
			setMovieAvailableLang(
				`${globalAny.language.available_audio_language} ${audio}<br>${globalAny.language.available_closed_caption_language} ${subtitle}`,
			);
		}
	};

	const retryTransactions = () => {
		navigation.replace(routePayment, { parentProductId, paymentType });
	};

	const steps = [
		{
			id: 0,
			title: <Title>{globalAny.language.card_details}</Title>,
		},
		{
			id: 1,
			title: <Title>{globalAny.language.billing_information}</Title>,
		},
		{
			id: 2,
			title: <Title>{globalAny.language.review_your_order}</Title>,
		},
	];
	//#endregion

	//#region Render Function
	const renderCardinalIframe = () => {
		return (
			<>
				<iframe title="cardinal" id="cardinal_collection_iframe" name="collectionIframe" height="10" width="10" style={stylesIframe}></iframe>
				<form id="cardinal_collection_form" method="POST" target="collectionIframe" action={deviceDataCollectionUrl}>
					<input id="cardinal_collection_form_input" type="hidden" name="JWT" value={cardinalAccessToken} />
				</form>
			</>
		);
	};

	const renderStepUpIframe = () => {
		return (
			<Provider>
				<Portal>
					<StyledModal visible={true} contentContainerStyle={customizeStyle}>
						<View>
							<iframe title="setup-up" name="step-up-iframe" height="400" width="400"></iframe>
							<form id="step-up-form" target="step-up-iframe" method="post" action={stepUrl}>
								<input type="hidden" name="JWT" value={stepUrlAccessToken} />
							</form>
						</View>
						{hostUrl.includes("localhost") ? (
							//  @ts-ignores
							<StyledSubmitButton>
								<TouchableOpacity onPress={closePayerAuth} style={{ backgroundColor: highlightColor, borderRadius: 8, padding: 5 }}>
									<Text style={{ color: white_smoke }}>{globalAny.language.submit}</Text>
								</TouchableOpacity>
							</StyledSubmitButton>
						) : (
							<></>
						)}
					</StyledModal>
				</Portal>
			</Provider>
		);
	};

	const renderButton = () => (
		<ButtonContainer isNarrow={isNarrow}>
			<RenderButton
				isNarrow={isNarrow}
				rent={rent}
				step={step}
				steps={steps}
				paymentType={paymentType}
				onPressNext={() => onPressNext()}
				onValidateStep={!onValidateStep() || disabledNext}
				onPressPrevious={() => onPressPrevious()}
				disabledPrevious={disabledPrevious}
				confirmExit={(back: any) => confirmExit(back)}
			/>
		</ButtonContainer>
	);

	//#endregion

	//#region useEffect
	useEffect(() => {
		init();
		init3dsCallback();
		initTransactionDetails();
	}, []);

	useEffect(() => {
		if (captureContext && flexMicroFormScriptLoaded === true) {
			setTimeout(() => {
				setLoading(false);
				initFlexMicroform(captureContext);
			}, 2000);
			return;
		}
		setLoading(true);
	}, [captureContext, flexMicroFormScriptLoaded]);

	useEffect(() => {
		window.addEventListener(
			"message",
			function (event) {
				const cardinalStagingUrl = "https://centinelapistag.cardinalcommerce.com";
				const cardinalProdUrl = "https://centinelapi.cardinalcommerce.com";
				if (event.origin === cardinalStagingUrl || event.origin === cardinalProdUrl) {
					const eventDetails = JSON.parse(event.data);

					setSessionId(eventDetails["SessionId"]);
					AppLogger.log("Device data collection completed.");
				}
			},
			false,
		);
	}, []);

	useEffect(() => {
		if (sessionId) {
			onCheckEnrollment(sessionId);
		}
	}, [sessionId]);

	useEffect(() => {
		(async () => {
			const result = movieStoreValue.titleDetails.titles[parentProductId];

			if (result?.metadata?.responseCode === 40058 || isNaN(parentProductId)) {
				setVisible(true);
				setToastMessage(wording.movieNotAvailable);
				setTimeout(() => {
					setSelectedTabs(0);
					location.replace("/");
				}, 3000);
				return;
			}

			if (result?.ownedstatus) {
				const [owned] = result.ownedstatus.filter((val: any) => val.owned === true).sort((a: any, b: any) => a - b);

				if (owned?.owned && owned?.transactionType !== 3) {
					setVisible(true);
					setToastMessage(wording.movieAlreadyOwned);
					setTimeout(() => {
						setSelectedTabs(0);
						location.replace("/");
					}, 3000);
				}
			}

			if (result?.metadata) {
				setMetadata(result?.metadata);
			}
		})();
	}, [route.params, movieStoreValue]);

	useEffect(() => {
		const onBack = () => {
			startCountdownAndHandleError();
		};
		window.addEventListener("popstate", onBack);

		return () => {
			window.removeEventListener("popstate", onBack);
		};
	}, []);

	useEffect(() => {
		narrowScreen = isNarrow;
	}, [isNarrow]);

	//#endregion

	return (
		<SafeAreaView style={{ flex: 1 }}>
			{!loading && (
				// @ts-ignores
				<StyledContainer isTermAndService={isTermOfService}>
					<TopAppBar
						leftIcon={closeIcon}
						leftTitleIcon={backIcon}
						leftIconWidth={92}
						screenTitle={isTermOfService ? title : metadata?.title}
						screenTitleBody={isTermOfService ? "" : getTitleBody()}
						onPressLeftIcon={() => confirmExit("close")}
						onPressLeftTitleIcon={() => confirmExit("back")}
						isNarrow={isNarrow}
					/>
					<StyledFormContainer isShow={!isTermOfService} isNarrow={isNarrow}>
						<StyledFrame isNarrow={isNarrow}>
							<StepperContainer isNarrow={isNarrow}>
								<Stepper
									orientation={isNarrow ? "vertical" : "horizontal"}
									marker={<Marker onPress={(step) => props.onPress(step)} stepCount={steps.length} />}
									currentStep={step}
									steps={steps}
								/>
							</StepperContainer>
							<ContentContainer isNarrow={isNarrow}>
								<CardDetails
									show={step === 0}
									isNarrow={isNarrow}
									cardName={cardName}
									setCardName={setCardName}
									cardExpiry={cardExpiry}
									setCardExpiry={setCardExpiry}
									firstName={firstName}
									setFirstName={setFirstName}
									lastName={lastName}
									setLastName={setLastName}
									debouncedOnChange={debouncedOnChange}
									isEmptyCardNumber={cardNumberDetails}
									isEmptyCVV={cardCVV}
									isExpiryError={expiryError}
									setExpiryError={setExpiryError}
								/>
								<BillingInformation
									show={step === 1}
									isNarrow={isNarrow}
									setAddress={setAddress}
									address={address}
									setAddress2={setAddress2}
									address2={address2}
									setCountry={setCountry}
									country={country}
									setState={setState}
									state={state}
									setCity={setCity}
									city={city}
									setPostalCode={setPostalCode}
									postalCode={postalCode}
									setCountryName={setCountryName}
									countryName={countryName}
									setStateName={setStateName}
									stateName={stateName}
									step={step}
								/>
								<PurchaseOptions
									show={step === 2}
									isNarrow={isNarrow}
									metadata={metadata}
									onPressTermsAndService={onPressTermsAndService}
									price={taxDetails}
									isRent={capitalize(paymentType) === rent}
								/>
							</ContentContainer>
							{isNarrow ? renderButton() : <></>}
						</StyledFrame>
						{!isNarrow ? renderButton() : <></>}
					</StyledFormContainer>
				</StyledContainer>
			)}
			{loading && !isNarrow && <PaymentLoader />}
			{loading && isNarrow && <PaymentNarrowLoader />}
			{isTermOfService && <PrivacyPolicy text={termOfService} />}
			<Toast
				visible={visible}
				text={toastMessage}
				label={labelText}
				type={type}
				onDismissSnackBar={onDismissSnackBar}
				duration={toastDuration}
				onPress={() => onPressToast(labelText)}
			/>

			{showConfirmModal && (
				<CustomizeDialogBox
					Header={
						capitalize(paymentType) === rent ? globalAny.language.cancel_rent_transaction : globalAny.language.cancel_purchase_transaction
					}
					Body={globalAny.language.validating_cancel_transaction}
					ButtonTextRight={globalAny.language.cancel}
					ButtonTextLeft={globalAny.language.ok.toUpperCase()}
					SingleButton={false}
					Width={680}
					Height={"auto"}
					TypeButtonColorLeft={ComponentTypeEnum.Primary}
					TypeButtonColorRight={ComponentTypeEnum.Secondary}
					onPressRight={() => setShowConfirmModal(false)}
					onPressLeft={() => {
						startCountdownAndHandleError();
						getConfirmCallBack();
					}}
				/>
			)}

			{isFlexLimit && (
				<CustomizeDialogBox
					Header={
						capitalize(paymentType) === rent ? globalAny.language.cancel_rent_transaction : globalAny.language.cancel_purchase_transaction
					}
					Body={globalAny.language.flex_limit_message}
					ButtonTextRight={globalAny.language.ok.toUpperCase()}
					SingleButton={true}
					Width={680}
					Height={"auto"}
					TypeButtonColorRight={ComponentTypeEnum.Primary}
					onPressRight={() => retryTransactions()}
				/>
			)}

			{isProcessPurchase && (
				<CustomizeDialogBox
					Header={metadata?.title}
					Body={globalAny.language.processing_order}
					Footer={movieAvailableLang}
					ButtonTextRight={globalAny.language.processing}
					SingleButton={!!isProcessPurchase}
					CloseButton={false}
					Width={680}
					Height={"auto"}
					TypeButtonColorRight={ComponentTypeEnum.Secondary}
					isProcessing={!!isProcessPurchase}
				/>
			)}

			<CarActivityDialog
				title={globalAny.language.car_in_motion_title}
				body={globalAny.language.car_in_motion_body}
				buttonText={globalAny.language.car_in_motion_back_to_movie}
				subText={globalAny.language.car_in_motion_subtext}
				onPress={() => {
					setSelectedTabs(0);
					navigationTitleDetails.navigate(routeTitleDetails, { parentProductId });
				}}
				show={carActivity === CarActivity.INMOTION}
			/>
			<button id="cs-3ds-callback-button" name="cs-3ds-callback-button" type="submit" onClick={closePayerAuth} hidden></button>
			{showAuthPayer ? renderStepUpIframe() : <></>}
			{renderCardinalIframe()}
		</SafeAreaView>
	);
};

export default PaymentScreen;
